import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useProductSizes() {
  const { token } = useContext(AuthContext);

  const [sizes, setSizes] = useState([]);

  useEffect(() => {
    if (!token) return;
    const loadSizes = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": token,
        };

        const res = await fetchWithInterceptor(
          "/api/sizes?isActive=true&limit=1000",
          { headers }
        );

        if (res?.ok) {
          const { rows } = await res.json();
          setSizes(rows || []);
        } else if (res) {
          console.error("Failed to load sizes:", res.status, res.statusText);
        }
      } catch (err) {
        console.error("Error loading sizes:", err);
      }
    };

    loadSizes();
  }, [token]);

  return { sizes };
}
